import React, {FC} from 'react';
import {IRestaurantResponse, ProviderTypeEnum} from 'types';

import {MetroSearch} from '../../../../metro/components/metro-search/MetroSearch';
import {GlobalSearch} from '../search/components/global-search';

interface IProps {
  providerType?: ProviderTypeEnum;
  providerName?: string;
  isMetro?: boolean;
  provider?: IRestaurantResponse;
}

const SearchComponent: FC<IProps> = ({providerType, provider, isMetro}) => {
  return isMetro ? (
    <MetroSearch providerType={providerType} provider={provider} />
  ) : (
    <GlobalSearch providerType={providerType} />
  );
};

export const Search = React.memo(SearchComponent);
